import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  MembershipItem,
  MembershipType,
} from '@interfaces/membership.interface';

@Component({
  selector: 'ark-membership-item',
  templateUrl: './membership-item.component.html',
  styleUrls: ['./membership-item.component.scss'],
})
export class MembershipItemComponent implements OnInit {
  @Input() data!: MembershipItem;
  @Input() deviceType: string = 'desktop';
  @Output() purchaseItem: EventEmitter<number> = new EventEmitter<number>();
  ctaText = '';
  ctaDisabled = false;
  purchasing = false;
  popupVisible = false;
  constructor() {}

  ngOnInit(): void {
    this.ctaText = this.data.current
      ? 'CURRENT PACKAGE'
      : this.data.type === MembershipType.PAID &&
        this.data.nft.sold === this.data.nft.total
      ? 'SOLD OUT'
      : 'SELECT';
    this.ctaText =
      this.data.freeDisabled && this.data.type === MembershipType.FREE
        ? '1-TIME USE ONLY'
        : this.ctaText;
    this.ctaDisabled =
      (this.data.freeDisabled && this.data.type === MembershipType.FREE) ||
      this.data.current ||
      (this.data.type === MembershipType.PAID &&
        this.data.nft.sold === this.data.nft.total);
  }

  purchase(): void {
    if (!this.ctaDisabled && !this.purchasing) {
      this.purchasing = true;
      setTimeout(() => (this.purchasing = false), 1000);
      this.purchaseItem.emit(this.data.id);
    }
  }

  openPopup(): void {
    this.popupVisible = true;
  }

  closePopup(): void {
    this.popupVisible = false;
  }

  gotoDocs(): void {
    window.open('https://docs.valuesmovement.org/welcome', '_blank');
  }

  get formattedMultiplier(): string {
    return (this.data?.multiplier ?? 0).toFixed(1);
  }
}
